import { apiClient } from 'config/api';

export type ResolveDecision = 'APPROVED' | 'REJECTED';

/**
 * Approves or rejects a pending customer registration
 * @param body - body payload request
 * @param body.id - pending customer id
 * @param body.decision - APPROVED or REJECTED
 */
async function postResolvePendingCustomer({
  id,
  decision,
}: {
  id: string;
  decision: ResolveDecision;
}) {
  const url = `/partner/customer/pending/${id}/resolve`;
  const response = await apiClient.post(url, { decision });
  return response.data;
}

export default postResolvePendingCustomer;
